export default __webpack_public_path__ + "static/media/Roobert-Bold.6502eb70.woff";